export interface Deal {
  id: string;
  title: string;
  description: string;
  category: string;
  image: string;
  originalPrice: number;
  currentPrice: number;
  discount: string;
  source: string;
  expiryDate: string;
  isHot: boolean;
  isNew: boolean;
  isFree: boolean;
  link: string;
}

export const deals: Deal[] = [
  {
    id: 'deal-1',
    title: '网易云音乐黑胶VIP月卡免费领',
    description: '新用户专享，免费领取网易云音乐黑胶VIP月卡，畅享无损音质和无广告体验。数量有限，先到先得！',
    category: 'free',
    image: 'https://readdy.ai/api/search-image?query=Music%20streaming%20app%20interface%20on%20smartphone%20with%20headphones%2C%20clean%20minimalist%20background%2C%20warm%20lighting%2C%20modern%20flat%20lay%20photography%2C%20soft%20shadows%2C%20elegant%20composition%20with%20music%20notes%20decorative%20elements&width=600&height=400&seq=deal-free-01&orientation=landscape',
    originalPrice: 18,
    currentPrice: 0,
    discount: '免费',
    source: '网易云音乐',
    expiryDate: '2026-08-15',
    isHot: true,
    isNew: false,
    isFree: true,
    link: '#',
  },
  {
    id: 'deal-2',
    title: '瑞幸咖啡满30减15元优惠券',
    description: '瑞幸咖啡全场通用优惠券，满30元立减15元，生椰拿铁、冰美式等热门饮品均可使用，每人限领一张。',
    category: 'coupon',
    image: 'https://readdy.ai/api/search-image?query=Iced%20latte%20coffee%20in%20clear%20plastic%20cup%20on%20wooden%20table%2C%20warm%20cafe%20atmosphere%2C%20soft%20natural%20lighting%20from%20window%2C%20minimalist%20coffee%20shop%20interior%2C%20cozy%20aesthetic%20with%20plant%20decoration&width=600&height=400&seq=deal-coupon-01&orientation=landscape',
    originalPrice: 30,
    currentPrice: 15,
    discount: '立减15元',
    source: '瑞幸咖啡',
    expiryDate: '2026-08-10',
    isHot: false,
    isNew: true,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-3',
    title: '小米手环8 Pro限时秒杀199元',
    description: '小米手环8 Pro限时特惠，原价399元，秒杀价仅需199元。1.74英寸AMOLED大屏，14天超长续航，支持150+运动模式。',
    category: 'flash-sale',
    image: 'https://readdy.ai/api/search-image?query=Black%20smart%20fitness%20band%20watch%20on%20white%20minimalist%20surface%2C%20display%20showing%20health%20data%2C%20clean%20product%20photography%20with%20soft%20even%20lighting%2C%20modern%20tech%20aesthetic%2C%20simple%20background&width=600&height=400&seq=deal-flash-01&orientation=landscape',
    originalPrice: 399,
    currentPrice: 199,
    discount: '5折',
    source: '小米官方',
    expiryDate: '2026-08-08',
    isHot: true,
    isNew: true,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-4',
    title: '京东PLUS会员体验卡免费领取',
    description: '京东PLUS会员7天体验卡免费领，享受免运费、专属折扣、双倍京豆等权益。新老用户均可参与活动。',
    category: 'free',
    image: 'https://readdy.ai/api/search-image?query=Online%20shopping%20membership%20card%20concept%2C%20premium%20golden%20card%20on%20clean%20white%20desk%2C%20e-commerce%20shopping%20bags%20in%20background%2C%20warm%20ambient%20lighting%2C%20luxury%20membership%20visual%2C%20elegant%20composition&width=600&height=400&seq=deal-free-02&orientation=landscape',
    originalPrice: 30,
    currentPrice: 0,
    discount: '免费体验',
    source: '京东',
    expiryDate: '2026-08-20',
    isHot: false,
    isNew: true,
    isFree: true,
    link: '#',
  },
  {
    id: 'deal-5',
    title: 'iPhone 15 Pro Max官网直降800元',
    description: 'Apple官方授权渠道，iPhone 15 Pro Max全系直降800元，支持12期免息分期，限量200台售完即止。',
    category: 'digital',
    image: 'https://readdy.ai/api/search-image?query=Latest%20iPhone%20smartphone%20titanium%20color%20on%20minimalist%20white%20surface%2C%20clean%20product%20photography%20with%20soft%20studio%20lighting%2C%20elegant%20tech%20product%20shot%2C%20simple%20background%20with%20subtle%20shadows&width=600&height=400&seq=deal-digital-01&orientation=landscape',
    originalPrice: 8999,
    currentPrice: 8199,
    discount: '直降800元',
    source: 'Apple授权店',
    expiryDate: '2026-08-12',
    isHot: true,
    isNew: false,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-6',
    title: '星巴克星冰乐买一送一券',
    description: '星巴克夏日特惠，任意大杯星冰乐买一送一，抹茶星冰乐、摩卡星冰乐等全系列参与。限门店使用。',
    category: 'food',
    image: 'https://readdy.ai/api/search-image?query=Green%20matcha%20frappuccino%20in%20Starbucks%20cup%20with%20whipped%20cream%2C%20cafe%20wooden%20table%2C%20warm%20afternoon%20sunlight%2C%20cozy%20coffee%20shop%20vibe%2C%20lifestyle%20food%20photography%20with%20bokeh%20background&width=600&height=400&seq=deal-food-01&orientation=landscape',
    originalPrice: 38,
    currentPrice: 19,
    discount: '买一送一',
    source: '星巴克',
    expiryDate: '2026-08-31',
    isHot: false,
    isNew: false,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-7',
    title: '网易严选纯棉T恤9.9元包邮',
    description: '网易严选夏日清仓，100%纯棉基础款T恤仅售9.9元包邮，多色可选，限购3件。面料柔软亲肤不缩水。',
    category: 'life',
    image: 'https://readdy.ai/api/search-image?query=Plain%20white%20cotton%20t-shirt%20folded%20neatly%20on%20light%20wooden%20surface%2C%20minimalist%20clothing%20photography%2C%20soft%20natural%20daylight%2C%20clean%20aesthetic%20with%20fabric%20texture%20detail%2C%20simple%20wardrobe%20essentials&width=600&height=400&seq=deal-life-01&orientation=landscape',
    originalPrice: 49,
    currentPrice: 9.9,
    discount: '2折',
    source: '网易严选',
    expiryDate: '2026-08-18',
    isHot: false,
    isNew: true,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-8',
    title: '兰蔻小黑瓶精华7ml体验装免费申领',
    description: '兰蔻官方活动，新会员注册即可免费申领小黑瓶精华肌底液7ml体验装，到专柜领取或付邮费邮寄到家。',
    category: 'beauty',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20skincare%20serum%20bottle%20on%20marble%20surface%2C%20minimalist%20beauty%20product%20photography%2C%20soft%20rose%20gold%20accents%2C%20clean%20white%20background%20with%20delicate%20flower%20petals%2C%20premium%20cosmetic%20aesthetic&width=600&height=400&seq=deal-beauty-01&orientation=landscape',
    originalPrice: 99,
    currentPrice: 0,
    discount: '免费申领',
    source: '兰蔻官方',
    expiryDate: '2026-09-01',
    isHot: true,
    isNew: false,
    isFree: true,
    link: '#',
  },
  {
    id: 'deal-9',
    title: '天猫超市满199减100元神券',
    description: '天猫超市周年庆大促，限量发放满199减100元超级神券，全场通用，零食饮料日用品均可使用，抢完即止。',
    category: 'coupon',
    image: 'https://readdy.ai/api/search-image?query=Online%20supermarket%20shopping%20concept%20with%20grocery%20items%20and%20discount%20tag%2C%20clean%20white%20minimalist%20background%2C%20fresh%20products%20arranged%20neatly%2C%20warm%20bright%20lighting%2C%20modern%20e-commerce%20visual&width=600&height=400&seq=deal-coupon-02&orientation=landscape',
    originalPrice: 199,
    currentPrice: 99,
    discount: '满199减100',
    source: '天猫超市',
    expiryDate: '2026-08-09',
    isHot: true,
    isNew: false,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-10',
    title: '索尼WH-1000XM5降噪耳机直降600',
    description: '索尼旗舰降噪耳机WH-1000XM5限时直降600元，行业顶级降噪技术，30小时续航，支持快充。官方授权正品保障。',
    category: 'digital',
    image: 'https://readdy.ai/api/search-image?query=Premium%20black%20wireless%20headphones%20on%20clean%20white%20surface%2C%20minimalist%20tech%20product%20photography%2C%20soft%20studio%20lighting%20with%20subtle%20highlights%2C%20modern%20audio%20equipment%20aesthetic%2C%20simple%20elegant%20composition&width=600&height=400&seq=deal-digital-02&orientation=landscape',
    originalPrice: 2499,
    currentPrice: 1899,
    discount: '直降600元',
    source: '索尼官方',
    expiryDate: '2026-08-14',
    isHot: false,
    isNew: false,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-11',
    title: '肯德基疯狂星期四套餐19.9元',
    description: '肯德基疯狂星期四特惠，黄金鸡块+薯条+可乐套餐仅需19.9元。每周四限定，到店或外送均可使用。',
    category: 'food',
    image: 'https://readdy.ai/api/search-image?query=Crispy%20fried%20chicken%20pieces%20with%20golden%20fries%20in%20paper%20box%2C%20fast%20food%20photography%2C%20warm%20yellow%20lighting%2C%20clean%20wooden%20table%20surface%2C%20appetizing%20food%20presentation%20with%20dip%20sauce&width=600&height=400&seq=deal-food-02&orientation=landscape',
    originalPrice: 39,
    currentPrice: 19.9,
    discount: '5折',
    source: '肯德基',
    expiryDate: '2026-08-13',
    isHot: false,
    isNew: true,
    isFree: false,
    link: '#',
  },
  {
    id: 'deal-12',
    title: '花西子蜜粉饼9.9元秒杀',
    description: '花西子空气蜜粉饼限时秒杀，原价129元现在仅需9.9元，定妆控油隐形毛孔，限量500份先到先得。',
    category: 'beauty',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pressed%20powder%20compact%20with%20intricate%20Chinese%20design%20on%20white%20marble%2C%20luxury%20makeup%20product%20photography%2C%20soft%20feminine%20lighting%2C%20delicate%20powder%20texture%20visible%2C%20premium%20cosmetic%20aesthetic&width=600&height=400&seq=deal-beauty-02&orientation=landscape',
    originalPrice: 129,
    currentPrice: 9.9,
    discount: '0.7折',
    source: '花西子官方',
    expiryDate: '2026-08-07',
    isHot: true,
    isNew: true,
    isFree: false,
    link: '#',
  },
];